import {
  ViewList,
  SubtitleSettingsStorage,
  AudioSettingsStorage,
  SubtitleSettings,
} from './appTypings';

export const itemViewsInitialState: ViewList = {};

export const initialSubtitleSettings: SubtitleSettings = {
  subtitles: undefined,
  subtitleBackground: 'transparent',
  subtitleSize: 'normal',
};

export const initialAudioSettings = {
  audio: undefined,
};

export const subtitleSettingsStorage: SubtitleSettingsStorage = {
  userSettings: {
    anonymous: initialSubtitleSettings,
  },
  state: 'ssr',
};

export const audioSettingsStorage: AudioSettingsStorage = {
  userSettings: {
    anonymous: initialAudioSettings,
  },
  state: 'ssr',
};
